document.addEventListener("DOMContentLoaded", () => {
    const menu = document.querySelector(".menu");
    const items = menu.querySelectorAll("li");
    const hoverBg = menu.querySelector(".hover-bg");
    const main = document.querySelector('main');
    items.forEach((item) => {
        item.addEventListener("mouseenter", () => {
            const rect = item.getBoundingClientRect();
            const menuRect = menu.getBoundingClientRect();

            hoverBg.style.width = `${rect.width}px`;
            hoverBg.style.left = `${rect.left - menuRect.left}px`;
            hoverBg.style.opacity = 1;
        });

        item.addEventListener("mouseleave", () => {
            hoverBg.style.opacity = 0;
        });
    });
    function isSP() {
        return window.innerWidth <= 768;
    }

    function checkFooterInView() {
        const footer = document.querySelector("footer");
        const footerTop = footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        return footerTop < windowHeight; // フッターが画面内に入ったら true
    }

    window.addEventListener("scroll", () => {
        const target = document.getElementById("tel_link");
        if (!target) return;

        if (isSP() && checkFooterInView()) {
            target.classList.add("hide");
        } else {
            target.classList.remove("hide");
        }
    });

    ScrollTrigger.matchMedia({
        "(max-width: 768px) and (pointer: coarse)": function () {
            const scrollBox = document.querySelector(".scrollBox");
            const panelCount = document.querySelectorAll(".busList li").length;
            const scrollLength = window.innerWidth * (panelCount - 2.5);

            // スクロール滑らかさのためにtransformの最適化
            gsap.set(scrollBox, { willChange: "transform" });

            gsap.to(scrollBox, {
                x: () => `-${scrollLength}px`,
                ease: "none",
                scrollTrigger: {
                    trigger: ".contents",
                    start: "top top",
                    end: () => `+=${scrollLength}`,
                    scrub: 1,
                    pin: true,
                    anticipatePin: 1,
                    pinSpacing: true,
                }
            });
        }
    });

    window.addEventListener('DOMContentLoaded', () => {
        const elements = document.querySelectorAll('.animate-target');
        elements.forEach(el => {
            const delay = parseInt(el.dataset.delay, 10) || 0;
            setTimeout(() => {
                el.classList.add('active');
            }, delay);
            setTimeout(() => {
                ScrollTrigger.refresh();
            }, 4500);
        });
    });
});

